module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/117-angola-e81457e01adedc07c3f71d972f481815.svg";